'use client';

import { AllProducts } from 'components/products/AllProducts';
import { HeroBanner } from 'components/products/HeroBanner';
import ShopBottomBar from 'components/products/ShopBottomBar';
import { getM1DataForStore } from 'content/products/m1';
import { getLegacyMerchData } from 'content/products/merch';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { isMCFCountry } from 'lib/region/countryUtils';
import { Currency } from 'utils/Currency';
import type { PackOffer } from 'content/products/packs/types';

const Products = ({
  region,
  packs,
}: {
  region: string;
  packs: PackOffer[];
}) => {
  const { store: regionStore, currency: regionCurrency } =
    useRegionLocale();
  const store = regionStore ?? ShopifyStore.ROW;
  const currency = regionCurrency ?? Currency.usd;
  const isMCF = isMCFCountry(region);

  // For MCF (EU) countries, use the EU store; otherwise use the resolved store
  const effectiveStore = isMCF ? ShopifyStore.EU : store;
  const effectiveCurrency = isMCF ? Currency.eur : currency;

  // M1 OTP config — pass the full config so the single card can access all plans
  const m1Data = getM1DataForStore(effectiveStore, region.toUpperCase());
  const m1OtpConfig = m1Data?.otp ?? undefined;
  const m1SubConfig = m1Data?.membership ?? undefined;

  // Merch products
  const merchProducts = getLegacyMerchData(effectiveStore);

  return (
    <>
      <main>
        <HeroBanner />
        <AllProducts
          merchProducts={merchProducts}
          packs={packs}
          currency={effectiveCurrency}
          m1OtpConfig={m1OtpConfig}
          m1SubConfig={m1SubConfig}
        />
      </main>
      <ShopBottomBar />
    </>
  );
};

export default Products;
